import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const productaredetailsApi = createApi({
  reducerPath: "productaredetailsApi",
  baseQuery,
  prepareHeaders: (headers) => {
    const token = localStorage.getItem("userToken");
    if (token) headers.set("Authorization", `Bearer ${token}`);
    headers.set("X-Request-Id", crypto.randomUUID());
    return headers;
  },
  tagTypes: ["productAreDetails"],
  endpoints: (builder) => ({

    createProductAreDetails: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/export/product/areDetails/${id}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: { exportAreDetails: data },
      }),
      invalidatesTags: ["productAreDetails"],
    }),

    getAreDetailsById: builder.query({
      query: ({ id }) => `export/product/areDetails/${id}`,
      transformResponse: (response) => {
        const data = response?.data ?? [];
        const normalized = Array.isArray(data) ? data : [data];
        return normalized.map((item, index) => ({
          ...item,
          SrNo: index + 1,
          id: item.areDetailsId, //  use backend's exportEntityId
        }));

      },
      providesTags: ["productAreDetails"],
    }),
    // 🔹 Get single invoice by Id
    getAreDetails: builder.query({
      query: ({ id, subId }) =>
        `export/product/areDetails/${id}/${subId}`,
      transformResponse: (response) => {
        const data = response?.data ?? [];
        const normalized = Array.isArray(data) ? data : [data];
        return normalized.map((item, index) => ({
          ...item,
          SrNo: index + 1,
          id: item.areDetailsId, //  use backend's exportEntityId
        }));

      },


      providesTags: ["productAreDetails"],
    }),

    updateProductAreDetails: builder.mutation({
      query: ({ id, subId, ...data }) => ({
        url: `/export/product/areDetails/${id}/${subId}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: { exportAreDetails: data },
      }),
      invalidatesTags: ["productAreDetails"],
    }),

    
    deleteProductAreDetails: builder.mutation({
      query: ({ id }) => ({
        url: `export/product/areDetails/${id}`,
        method: "DELETE",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
      }),
      invalidatesTags: ["productAreDetails"],
    }),


  }),
});

export const {
  useCreateProductAreDetailsMutation,
  useUpdateProductAreDetailsMutation,
  useDeleteProductAreDetailsMutation,

  useLazyGetAreDetailsByIdQuery,
  useLazyGetAreDetailsQuery


} = productaredetailsApi;
